export default __webpack_public_path__ + "static/8-919b126d30194b7435458a6aa9e317a5.jpg";